import React, { useState } from 'react'; // eslint-disable-line no-unused-vars
import { Button } from '@mui/material';
import { WYRDialog } from './components';

export interface MainProps {}

export const Main = ({}: MainProps): React.JSX.Element => {
  const [openDialog, setOpenDialog] = useState<boolean>(false);

  return (
    <React.Fragment>
      {openDialog && (
        <WYRDialog
          onClose={() => {
            setOpenDialog(false);
          }}
        />
      )}
      <Button
        variant="contained"
        color="primary"
        sx={{ height: 'auto' }}
        fullWidth={true}
        onClick={() => {
          setOpenDialog(true);
        }}
      >
        Would You Rather?
      </Button>
    </React.Fragment>
  );
};
